import { ActionPopover } from './wrappers/ActionPopover'
import { AddWhitelistedAddressContent } from './content/AddWhitelistedAddressContent'
import { useNavigation } from '../../contexts/NavigationContext'
import {
  useCreateWhitelistedAddressMutation,
  useGetCompanyWhitelistedAddressesQuery,
} from '../../generated/graphql'

interface AddWhitelistedAddressPopoverProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onMobileClick?: () => void
  isActive?: boolean
}

function AddWhitelistedAddressIcon({ isSelected }: { isSelected?: boolean }) {
  const iconSrc = isSelected
    ? '/icons/add-whitelisted-address-selected.svg'
    : '/icons/add-whitelisted-address.svg'

  return <img src={iconSrc} alt="Add Whitelisted Address" className="w-8 h-8" />
}

export function AddWhitelistedAddressPopover({
  open,
  onOpenChange,
  onMobileClick,
  isActive,
}: AddWhitelistedAddressPopoverProps) {
  const { selectedCompanyId } = useNavigation()
  const [, createAddress] = useCreateWhitelistedAddressMutation()

  // Get existing addresses to check for duplicates
  const [{ data: existingAddressesData }] = useGetCompanyWhitelistedAddressesQuery({
    variables: { companyId: selectedCompanyId || '' },
    pause: !selectedCompanyId,
  })

  return (
    <ActionPopover
      open={open}
      onOpenChange={onOpenChange}
      trigger={<AddWhitelistedAddressIcon isSelected={open || isActive} />}
      onMobileClick={onMobileClick}
      isActive={isActive}
    >
      <AddWhitelistedAddressContent
        onSuccess={() => onOpenChange(false)}
        existingAddresses={existingAddressesData?.getCompanyWhitelistedAddresses || []}
        onCreateWhitelistedAddress={createAddress}
      />
    </ActionPopover>
  )
}
